import styled from 'styled-components';
import {
  Subtitle as DefaultSubtitle,
  Text,
  Checkbox as DefaultCheckbox,
  Typography,
} from '~components';

export const FieldRow = styled.div`
  > *:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing.km8};
  }

  > *:last-child {
    margin-bottom: ${({ theme }) => theme.spacing.km6};
  }
`;

export const Container = styled.section`
  margin-top: ${({ theme }) => theme.spacing.km10};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const Checkbox = styled(DefaultCheckbox)`
  align-self: flex-end;
  margin-bottom: ${({ theme }) => theme.spacing.km3};

  label {
    display: flex;
    align-items: center;
  }

  && {
    @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
      margin-left: ${({ theme }) => theme.spacing.km0};
      margin-bottom: ${({ theme }) => theme.spacing.km8};
    }
  }
`;

export const CheckboxLabel = styled(Typography).attrs({ as: 'span' })`
  font-size: ${({ theme }) => theme.font.size.m4};
  color: ${({ theme }) => theme.color.text.neutral.default};
  margin-right: ${({ theme }) => theme.spacing.km4};
  letter-spacing: -0.03em;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-right: ${({ theme }) => theme.spacing.km0};
  }
`;

export const Content = styled.section`
  margin-bottom: 72px;
`;

export const Subtitle = styled(DefaultSubtitle)`
  margin-top: ${({ theme }) => theme.spacing.km2};
  margin-bottom: ${({ theme }) => theme.spacing.km6};
  font-size: ${({ theme }) => theme.font.size.m5};
  font-weight: ${({ theme }) => theme.font.weight.bold};
`;

export const Description = styled(Text)`
  display: block;
  letter-spacing: -0.03em;
  margin-top: ${({ theme }) => theme.spacing.km4};
  margin-bottom: ${({ theme }) => theme.spacing.km6};
`;
